var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAgentBuilderInactive = function SvgAgentBuilderInactive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#agent_builder-inactive_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D6E5F2",
    fillRule: "evenodd",
    d: "M4.651 4.537h6.666c-.865 1.595-.175 3.948 2.071 4.338.738.13 1.34.653 1.573 1.356H4.271v9.111c0 .21.17.38.38.38h13.666a.38.38 0 0 0 .38-.38v-6.54c.978-.247 1.837-.98 2.117-2.202l.036-.16c.03-.13.072-.255.125-.376v9.278A2.657 2.657 0 0 1 18.317 22H4.651a2.658 2.658 0 0 1-2.657-2.658V7.194A2.657 2.657 0 0 1 4.65 4.537Zm1.462 7.343a.95.95 0 0 1 1.343 0l2.277 2.278a.95.95 0 0 1 0 1.343l-2.277 2.277a.95.95 0 0 1-1.343-1.342l1.607-1.604-1.605-1.608a.95.95 0 0 1 0-1.342l-.002-.002Zm4.278 5.227a.95.95 0 0 1 .949-.949h2.278a.949.949 0 1 1 0 1.898H11.34a.95.95 0 0 1-.95-.949Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B2C9DE",
    d: "M16.92 1.609c.348-.913 1.64-.913 1.987 0l.537 1.41c.27.708.829 1.267 1.537 1.537l1.41.537c.913.348.913 1.639 0 1.987l-1.41.536c-.708.27-1.268.83-1.538 1.538l-.536 1.41c-.348.913-1.64.913-1.987 0l-.537-1.41a2.657 2.657 0 0 0-1.537-1.538l-1.41-.536c-.913-.348-.913-1.64 0-1.987l1.41-.537a2.657 2.657 0 0 0 1.537-1.538l.537-1.41Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "agent_builder-inactive_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgAgentBuilderInactive;